import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../../components/owner/PageHeader';
import PackageForm from './PackageForm';
import { fetchPackageById, fetchBranchNames, savePackage } from '../../../services/gym/catalogApi';
import { usePanelToast } from '../../../context/PanelToastContext';
import '../../owner/ownerPages.css';
import './packages.css';

function EditPackage() {
  const toast = usePanelToast();
  const { id } = useParams();
  const navigate = useNavigate();
  const [pkg, setPkg] = useState(null);
  const [branchOptions, setBranchOptions] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [packageData, branches] = await Promise.all([
          fetchPackageById(id),
          fetchBranchNames(),
        ]);
        if (!active) return;
        setPkg(packageData);
        setBranchOptions(branches);
      } catch (err) {
        if (active) setError(err.message || 'Failed to load package');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [id]);

  if (loading) {
    return <p className="owner-placeholder-text">Loading package...</p>;
  }

  if (!pkg) {
    navigate('/admin/packages', { replace: true });
    return null;
  }

  const handleSubmit = async (form) => {
    try {
      await savePackage(form, id);
      toast.showUpdated('Package');
      navigate('/admin/packages');
    } catch (err) {
      setError(err.message || 'Failed to update package');
    }
  };

  return (
    <div>
      <PageHeader title="Edit Package" subtitle={`Editing: ${pkg.name}`} />
      {error && <p className="owner-placeholder-text owner-mb-16">{error}</p>}
      <div className="owner-card package-form-card">
        <PackageForm
          initialData={{
            name: pkg.name,
            serialNo: pkg.serialNo ?? '',
            benefits: pkg.benefits,
            status: pkg.status,
            branch: pkg.branch,
          }}
          branchOptions={branchOptions}
          submitLabel="Save Changes"
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/packages')}
        />
      </div>
    </div>
  );
}

export default EditPackage;
